import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Form, Input, Drawer, Button, Row, Col, DatePicker, message } from "antd";
import { updateGlobalLeave, getGlobalLeaves } from "../../../../actions/globalLeaveAction";
import moment from "moment";

const { RangePicker } = DatePicker;

const UpdateGlobalLeave = ({ visible, onCancel, setUpdatelist, editData }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    if (editData) {
        form.setFieldsValue({
        title: editData.title,
        note: editData.note,
        dateRange: [
            moment(editData.leaveStart, "YYYY-MM-DD"),
            moment(editData.leaveEnd, "YYYY-MM-DD")
        ],
        });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const onClose = () => {
    form.resetFields();
    onCancel();
  };

  const onFinish = async (values) => {
    if (!editData) return;

    const payload = {
        title: values.title,
        leaveStart: values.dateRange[0].format("YYYY-MM-DD"),
        leaveEnd: values.dateRange[1].format("YYYY-MM-DD"),
        note: values.note || "",
    };

    try {
      await dispatch(updateGlobalLeave(editData.id, payload));
      message.success("Global Leave updated successfully");
      setUpdatelist(false); // trigger refresh in parent
      onClose();
      dispatch(getGlobalLeaves());
    } catch (err) {
      console.error(err);
      message.error("Something went wrong!");
    }
  };

  return (
    <Drawer
      title="Update Global Leave"
      width={400}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => form.submit()}>
            Update
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter a title" }]}
            >
              <Input placeholder="e.g., Eid Holiday" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="dateRange"
              label="Leave Period"
              rules={[{ required: true, message: "Please select start and end date" }]}
            >
              <RangePicker />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="note" label="Note">
              <Input.TextArea rows={3} placeholder="Optional notes" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default connect(null, { updateGlobalLeave })(UpdateGlobalLeave);
